import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingReviewTypeStore from 'stores/coaching/CoachingReviewTypeStore';
import TooltipMenu from 'components/pure/tooltips/TooltipMenu';
import {Menu, MenuItem} from 'material-ui';
import DropDownMenuButton from 'components/pure/utils/DropDownMenuButton';
import Button from '@material-ui/core/Button';
import AuthStore from 'stores/AuthStore';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import withAdHocPlanDialog from 'components/coaching/withAdHocPlanDialog';
import CoachingReviewTypeActions from 'actions/coaching/CoachingReviewTypeActions';

@connectToStores
class ManagerCoachingButton extends React.PureComponent {
  static getStores() {
    return [CoachingReviewTypeStore];
  }

  static getPropsFromStores() {
    return {reviewTypes: CoachingReviewTypeStore.getState().types};
  }

  componentDidMount() {
    CoachingReviewTypeActions.fetchAllReviewTypes.defer();
  }

  render() {
    const {reviewTypes, onCreatePlan} = this.props;
    const hasNonCallType = reviewTypes.some(t => !t.includesCalls);
    const manager = AuthStore.getState().user;

    return (
      <div className="manager-coaching-button">
        {hasNonCallType ? (
          <DropdownVer {...this.props} manager={manager} />
        ) : (
          <ButtonVer onCreatePlan={onCreatePlan} manager={manager} />
        )}
      </div>
    );
  }
}

function DropdownVer({onCreatePlan, onCoachNow, manager}) {
  return (
    <TooltipMenu
      menu={
        <Menu>
          <MenuItem primaryText="Coach Now" onClick={() => onCoachNow({})} />
          <MenuItem
            primaryText="Create Coaching Plan"
            onClick={() => onCreatePlan({coach: manager})}
          />
        </Menu>
      }>
      <DropDownMenuButton className="ev-button">Create Coaching Plan</DropDownMenuButton>
    </TooltipMenu>
  );
}

function ButtonVer({onCreatePlan, manager}) {
  return (
    <Button
      variant="contained"
      color="primary"
      className="ev-button"
      onClick={() => onCreatePlan({coach: manager})}>
      Create Coaching Plan
    </Button>
  );
}

export default withCoachingPlanWizard(withAdHocPlanDialog(ManagerCoachingButton));
